import { HeroTextAlert } from "src/components/generic/HeroTextAlert"

export type EmailSignupFeedbackProps = {
  heading: string
  message: string
}

export const EmailSignupFeedback = ({ heading, message }: EmailSignupFeedbackProps) => {
  return (
    <div className="mx-auto w-full max-w-100">
      <HeroTextAlert heading={heading} message={message} />
    </div>
  )
}
